export class KpHeaderService {
    public static serviceName = 'kpHeaderService';

    /*@ngInject*/
    constructor(private GLOBAL_SEARCH_INPUT_ENABLED: boolean) {
    }

    public get isGlobalSearchInputEnabled(): boolean {
        return this.GLOBAL_SEARCH_INPUT_ENABLED;
    }
}